import PropTypes from "prop-types";

const isBlank = value => value === null || value === undefined || value === "";

/**
 * Label/value rows for the secondary facts of an entry. A row with no value is
 * left out, so an entry never prints a label with nothing after it.
 */
const EntryDetails = ({ rows }) => {
  const shown = rows.filter(({ value }) => !isBlank(value));
  if (!shown.length) {
    return null;
  }

  return (
    <dl
      data-slot="entry-details"
      className="tw:m-0! tw:grid tw:grid-cols-[max-content_1fr] tw:gap-x-3 tw:gap-y-0.5 tw:text-sm"
    >
      {shown.map(({ label, value }) => (
        <div key={label} className="tw:contents">
          <dt className="tw:text-(--color-text-secondary)">{label}</dt>
          <dd className="tw:m-0! tw:min-w-0 tw:break-words tw:text-(--color-text-primary)">
            {value}
          </dd>
        </div>
      ))}
    </dl>
  );
};

EntryDetails.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ).isRequired,
};

export default EntryDetails;
